import React, {Fragment} from 'react';
import Select from 'react-select';
import PreLoginPage from '../../views/core/PreLoginPage';


// const options = [
//     { label: 'Class 4', value: 1},
//     { label: 'Class 5', value: 2},
//     { label: 'Class 6', value: 3},
//     { label: 'Class 7', value: 4},
//     { label: 'Class 8', value: 5},
//     { label: 'Class 9', value: 6},
//     { label: 'Class 10', value: 7}

//   ];

class RemedialSelectDropdown extends PreLoginPage {
  constructor(props) {
    super(props)
    this.state = {
        options:null,
        selectedContactOption:null,
        dataLoaded:false
    }
    
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount(){
    let options = this.props.getRemedialDDData();
    this.setState({options:options},
      (()=>{
        this.setState({selectedContactOption:options[0],dataLoaded:true})
      })
    );
    
  }


  handleChange(selectedOption){
    this.setState({ selectedContactOption:selectedOption});
    if(typeof this.props.callBack === "function"){
      this.props.callBack(selectedOption);
    }
  }


  render() {
    if(this.state.dataLoaded){
      return(
        <Select
        closeMenuOnSelect={false}
        isMulti={false}
        onChange={this.handleChange}
        options={this.state.options}
        value={this.state.selectedContactOption}
        isSearchable={false}
      />
      )
    }else{
      return(
        <Fragment></Fragment>
      )
    }
      
  }

  //value={this.state.selectedContactOption}
  
}
export default RemedialSelectDropdown;


// WEBPACK FOOTER //
// ./src/views/login/RemedialSelectDropdown.js